import type { FundingMethod } from '@/models/types';
import { Banknote, Building2, Handshake, Minus } from 'lucide-react';
import { Button } from '../../ui/button';
import type { Option } from '../../ui/combobox/combobox-popover';

export const FUNDING_METHOD_OPTIONS_MAP: Option<FundingMethod>[] = [
  {
    value: 'none',
    label: 'No funding method',
    icon: <Minus className="size-3.5" />,
  },
  { value: 'cash', label: 'Cash', icon: <Banknote className="size-3.5" /> },
  { value: 'loan', label: 'Loan', icon: <Handshake className="size-3.5" /> },
  {
    value: 'outside_financing',
    label: 'Outside Financing',
    icon: <Building2 className="size-3.5" />,
  },
];

const FundingMethodBadge = ({
  value: fundingMethod,
  hideCopy,
}: {
  value?: FundingMethod;
  hideCopy?: boolean;
}) => {
  return (
    <Button variant="ghost" className="p-1 h-fit">
      {
        FUNDING_METHOD_OPTIONS_MAP.find(
          (option) => option.value === fundingMethod,
        )?.icon
      }
      {!hideCopy && (
        <p className="rounded text-xs  text-gray-600">
          {
            FUNDING_METHOD_OPTIONS_MAP.find(
              (option) => option.value === fundingMethod,
            )?.label
          }
        </p>
      )}
    </Button>
  );
};

export default FundingMethodBadge;
